<style scoped>

    .img-temp-list {
        padding-left: 0;
        display: flex;
        align-items: center;
        flex-warp: warp;
    }

    .img-temp-item {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;
    }

    .img-temp-item img {
        width: 100%;
        height: 100%;
    }
    .img-temp-item:hover .img-action {
        opacity: 1;
    }

    .img-temp-item .img-action {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        opacity: 0;
    }
    .img-action i {
        font-size: 20px;
        color: #fff;
        margin-left: 15px;
        cursor: pointer;
    }
    .img-action i:first-child {
        margin-left: 0;
    }
</style>
<template>
<el-row>
    <el-col :span="18">

        <el-form :model="productForm" addAction="lcwpgoods/insertSecondHandCar.action" selectAction="lcwpgoods/selectSecondHandCar.action" editAction="lcwpgoods/editSecondHandCar.action"  v-form :rules="rules" ref="ruleForm" label-width="150px">
            <el-form-item label="车辆照片" prop="photo">

                    <div  v-for="(item, i) in productForm.photo" :key="i" style="display: inline;margin-left: 10px">
                        <el-image
                                style="width: 200px; height: 200px"
                                fit="cover"
                                :src="imageBaseUrl+item"
                                :preview-src-list="[imageBaseUrl+item]">
                        </el-image>
                    </div>

            </el-form-item>
            <el-form-item label="车型" prop="goodsName">
                <el-input   v-model="productForm.goodsName" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="车架号" prop="vin">
                <el-input   v-model="productForm.vin" readonly="readonly"></el-input>
            </el-form-item>
          <el-form-item label="车身颜色" prop="color">
            <el-input   v-model="productForm.color" readonly="readonly"></el-input>
        </el-form-item>

          <el-form-item label="车牌归属地" prop="licenseAddress" >
              <el-input   v-model="productForm.licenseAddress" readonly="readonly"></el-input>
          </el-form-item>

          <el-form-item label="初次上牌时间" prop="licenseTime">
            <el-date-picker  readonly="readonly"
              v-model="productForm.licenseTime"
              type="date"
             >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="行驶里程(万公里)" prop="mileage">
              <el-input   v-model="productForm.mileage" type="number" readonly="readonly"></el-input>
          </el-form-item>

            <el-form-item label="保险到期时间" prop="insuranceExpirationDate">
                <el-date-picker readonly="readonly"
                                v-model="productForm.insuranceExpirationDate"
                                type="date"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="年检到期时间" prop="inspectionExpirationDate">
                <el-date-picker readonly="readonly"
                                v-model="productForm.inspectionExpirationDate"
                                type="date"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="车源所在地"  prop="locationCity">
                <el-input   v-model="productForm.locationCity"  readonly="readonly"></el-input>
            </el-form-item>

          <el-form-item label="批发价格(万元)"  prop="businessPrice">
              <el-input   v-model=" productForm.businessPrice"  readonly="readonly"></el-input>
          </el-form-item>

            <el-form-item label="联系手机"  prop="phone">
                <el-input   v-model="productForm.phone"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="官方指导价"  prop="officePrice">
                <el-input   v-model=" productForm.officePrice"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="使用性质"  prop="useNature">
                <el-input   v-model=" productForm.useNature"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="过户次数"  prop="transferFrequency">
                <el-input   v-model=" productForm.transferFrequency"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="上市时间"  prop="listdate">
                <el-input   v-model=" productForm.listdate"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="排放标准"  prop="environmentalstandards">
                <el-input   v-model=" productForm.environmentalstandards"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="排量"  prop="displacement">
                <el-input   v-model=" productForm.displacement"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="变速箱类型"  prop="geartype">
                <el-input   v-model=" productForm.geartype"  readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="补充说明" prop="goodsDesc">
                <el-input v-model="productForm.goodsDesc" type="textarea"  readonly="readonly"></el-input>
            </el-form-item>

            <!--   <el-form-item>
                   <el-button type="primary">确定发布</el-button>
               </el-form-item>-->
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form>

    </el-col>
</el-row>

</template>

<script>
import cityCascader from '@/components/cityCascader'
import ChannelModel from '@/framework/models/channelModel'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import BasicPager from '../../../mixins/BasicPager'
import Config from '@/framework/configs/Config'
import SearchAreaInput from '@/components/SearchAreaInput'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'add-plus-second-handCar',
  extends: BasicPager,
  data: function () {
    var checkPrice = (rule, value, callback) => {
      if (value < 100 || value > 10000000) {
        return callback(new Error('请填写100-10000000之间的整数（单位元）'))
      }
      callback()
    }

    var checkMileage = (rule, value, callback) => {
      if (value < 0.01 || value > 1000) {
        return callback(new Error('请填写0.01-1000之间的数值（单位万公里）'))
      }

      let match = value + ''.match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        callback(new Error('小数点只能保留两位哦！'))
      }

      callback()
    }

    return {
      imageBaseUrl: Config.imageUrl,
      dialogVisible: false,
      dialogImageUrl: null,
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      productForm: {
        type: '新车',
        productInfo: null,
        seriesId: null,
        brandId: null,
        seriesName: null,
        productName: null,
        priceInfo: null,
        photo: [],
        businessId: null,
        currentPrice: null,
        licenseAddress: null
      },
      rules: {

      }
    }
  },
  watch: {
    'productForm.productType': function (productType) {
      this.productForm.brandId = null
      this.productForm.seriesId = null
      this.productForm.seriesName = null
      this.productForm.productName = null
      this.productForm.photo = []
      this.$refs['brand-and-series-select'].clear()
    }
  },
  components: {
    BrandAndSeriesCategoriesSelect,
    cityCascader,
    SearchAreaInput
  },
  created: function () {
    let params = this.$route.params

    this.productForm.id = params.goodsId
    // let businessProductId = parseInt(params.businessProductId)
    // this.productForm.id = businessProductId
    if (params.businessId) {
      let businessId = parseInt(params.businessId)
      this.productForm.businessId = businessId
    }

    if (params.carShowId) {
      this.productForm.carShowId = params.carShowId
    }
  },
  methods: {
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    onLicenseAddressChanged: function (addressInfo) {
      let city = addressInfo.province + ' ' + addressInfo.city
      this.productForm.licenseAddress = city
      // this.$set(this.productForm,'licenseAddress',labels.join(' '))
    },
    onTypeChange: function () {
      this.productForm.photo = []
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      //  String goodsName, String goodsDesc,Integer currentPrice,String officePrice,Integer brandId,Integer seriesId,String categoryIds,
      //                                            String brand,String series,String photo,@RequestAttribute Integer businessId
      // 商品名
      this.productForm.goodsName = brandInfo.name + ' ' + seriesInfo.name + ' ' + categoriesInfo.name

      // 官方指定价
      this.productForm.officePrice = categoriesInfo.price

      // 品牌车系车型
      this.productForm.brandId = brandInfo.id
      this.productForm.brand = brandInfo.name
      this.productForm.seriesId = seriesInfo.id
      this.productForm.series = seriesInfo.name

      this.productForm.categoryId = categoriesInfo.id
      this.productForm.category = categoriesInfo.name

      // let categoryIds =  []
      // for (var i = 0; i < categoriesInfo.length; i++) {
      //   let item = categoriesInfo[i]
      //   categoryIds.push(item.id)
      // }
      // this.productForm.categoryIds = categoryIds.join(',')

      // 添加照片
      // this.productForm.photo = []
      //
      // if(this.productForm.type== '新车'){
      //   let name = seriesInfo.imgUrl.replace('https://csz-test.oss-cn-hangzhou.aliyuncs.com/', '').replace('https://csz-public.oss-cn-hangzhou.aliyuncs.com/', '');
      //   this.productForm.photo.push({
      //       name: name,
      //       url: seriesInfo.imgUrl
      //   })
      //
      //   if (!seriesInfo) {
      //       this.productForm.photo = []
      //       return;
      //   }
      // }
    },

    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 15MB!')
          reject(new Error('上传头像图片大小不能超过 15MB!'))
          return
        }

        if (_this.productForm.photo.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.components[2].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    },
    onFilterParams: function (params) {
      params.currentPrice = parseInt(params.currentPrice * 100)

      // 只保留省市
      let licenseAddress = params.licenseAddress
      if (licenseAddress) {
        let addr = licenseAddress.split(' ')
        if (addr && addr.length === 3) {
          params.licenseAddress = addr[0] + ' ' + addr[1]
        }
      }
    },
    onSelectInfo: function (dataInfo) {
      this.productForm.businessPrice = new Number(dataInfo.datas.businessPrice / 1000000).valueOf()
      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
      }
    }
  }
}

</script>
